webpackJsonp([99053166012536],{

/***/ 977:
/***/ (function(module, exports) {

	module.exports = {"data":{"currentChallengeMarkdown":{"html":"<div>\n          <div\n            class=\"gatsby-resp-iframe-wrapper\"\n            style=\"padding-bottom: 56.25%; position: relative; height: 0; overflow: hidden;margin-bottom: 1.0725rem\"\n          >\n            <iframe src=\"https://www.youtube.com/embed/oQArwLjIadM\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen style=\"\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n          \"></iframe>\n          </div>\n          </div>","frontmatter":{"templateKey":"blog-post","isPersonal":false,"date":"March 20, 2018","path":"/crab-race","isCompleted":true,"isFailed":false,"title":"Crab Lace","description":"Conduct a crab race","author":"David Miller","difficulty":"medium","emotion":"Amused","location":"Okinawa, Japan","coordinates":[26.202423,127.287474]}},"commentsMarkdown":null},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---crab-race-47f74415612cf72cbf13.js